<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>

            <el-form-item label="供应商：">
                <el-select v-model="searchForm.supplierCode" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input placeholder="请输入ICCID号" v-model.trim="searchForm.iccid" @keyup.enter.native="getBackgroundTopUpOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input placeholder="请输入订单号" v-model.trim="searchForm.orderNo" @keyup.enter.native="getBackgroundTopUpOrderListHandle" clearable></el-input>
            </el-form-item>

            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getBackgroundTopUpOrderListHandle">查询</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="confirmExportDialogVisible = true">导出Excel</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"
		  >
            <el-table-column type="index" label="序号"  width="50" align="center"></el-table-column>
            <el-table-column prop="orderNo" label="订单号"  width="170"  align="center"></el-table-column>
            <el-table-column label="ICCID号"   width="170" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号"  align="center"></el-table-column>
            <el-table-column prop="packageName" label="套餐名"  align="center"></el-table-column>
            <el-table-column prop="investStateName" label="充值状态"  align="center"></el-table-column>

            <el-table-column prop="createTypeName" label="订单来源"  align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商"  align="center"></el-table-column>
            <el-table-column prop="supplierTypeCodeName" label="卡来源"  align="center"></el-table-column>
            <el-table-column prop="createTime"  label="下单时间"  width="150"  align="center"></el-table-column>
        </el-table>
 <div class="pagination-container">
   <el-pagination
     :current-page="tbpg.currentPage"
     :page-sizes="[10,20,500,2000,5000,10000]"
     :page-size="tbpg.pageSize"
     :total="tbpg.total"
     background layout="total, sizes, prev, pager, next, jumper"
     @size-change="handleSizeChange"
     @current-change="handleCurrentChange"
   />
 </div> 

        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOrderInfoHandle">确 定</el-button>
            </span>
        </el-dialog>    
 
    </div>
</template>
<script>
import {getBackgroundTopUpOrderList, getSecondBackList,exportOrderInfo, getOrderStateList, getOrderSourceList, backMoney, backMoneyDetail,resetOrderState} from '@/api/order.js'
import common from '@/utils/common.js'

export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                supplierCode: '',
                iccid: '',
                orderNo: '',
                investType: '',
                time: '',
                payState: '',
                createType: ''
            },
            orderState: [],
            orderSource: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            orderDetailForm: {},
            branchSupplierOption: [],
            currentOrderNo_back: '',
            tbpg_back: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },
            rowData:{},

            confirmExportDialogVisible : false,//导出确认框

        }
    },
    methods: {
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getBackgroundTopUpOrderListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getBackgroundTopUpOrderList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        exportOrderInfoHandle(){
            let _that = this;
            common.deleteSpaceKey(_that.searchForm); 
            exportOrderInfo(_that.searchForm).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
                this.confirmExportDialogVisible = false;
            }).catch(err=>console.error(err));
        },


        handleSizeChange(val){
            if(this.backVisible || this.backMoneyDetailVisible){
                this.tbpg_back.pageSize = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.pageSize = val;
                this.getBackgroundTopUpOrderListHandle();
            }

        },
        handleCurrentChange(val){
            if(this.backVisible){
                this.tbpg_back.currentPage = val;
                this.showSecondBackList(this.currentOrderNo_back);
            }else{
                this.tbpg.currentPage = val
                this.getBackgroundTopUpOrderListHandle();                
            }
        },
    },

    created(){
        this.getBackgroundTopUpOrderListHandle();
        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
        getOrderStateList().then(res => {
            if(res.data.code == 200){
                this.orderState = res.data.data;
            }
        })
        getOrderSourceList().then(res => {
            if(res.data.code == 200){
                this.orderSource = res.data.data;
            }
        })
    }
}
</script>
<style lang="less" scoped>
    .label-defined{
        display: inline-block;
        height: 32px;
        line-height: 32px;
    }

    .text-align-left{
        text-align:left
    }

    .many {
        display: flex;
        justify-content: space-between;
        label {
            display: block;
            line-height: 36px;
        }
        .uploadOuter {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 180px;
            min-height: 100px;
            max-height: 250px;
            border: 1px dashed #e5e5e5;
            box-sizing: border-box;
            input[type=file] {
                position: absolute;
                top: 0;
                width: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
            }                
            img {
                width: 100%;
                height: 100%;
            }
        }
    }

</style>

